import { z } from 'zod';

export const zodUnitMappingByIdentifierAndIssuerSearchParamsSchema = z.object({
  issuerId: z.uuid(),
  unitIdentifier: z.string(),
});
